// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"StatusIcon_statusIcon__SFwN5"};